import { render, staticRenderFns } from "./FollowUpList.vue?vue&type=template&id=5e7dfe8a&scoped=true&"
import script from "./FollowUpList.vue?vue&type=script&lang=ts&"
export * from "./FollowUpList.vue?vue&type=script&lang=ts&"
import style0 from "./FollowUpList.vue?vue&type=style&index=0&id=5e7dfe8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7dfe8a",
  null
  
)

export default component.exports